/* eslint-disable prefer-destructuring */
/* eslint-disable no-shadow */

const state = {
	'query/posts': {
		search: '',
		status: [],
		tags: [],
		dates: [],
		limit: 50,
	},
	'query/pendingPosts': {
		search: '',
		status: ['pending'],
		tags: [],
		dates: [],
		limit: 36,
	},
};

const getters = {
	query: state => type => state[`query/${type}`],
};

const mutations = {
	SET_QUERY_FILTER(state, { filter, type }) {
		state[`query/${type}`] = filter;
	},
	RESET_ALL_FILTERS(state) {
		state['query/posts'] = {
			search: '',
			status: [],
			tags: [],
			dates: [],
			limit: 36,
		};

		state['query/pendingPosts'] = {
			search: '',
			status: ['pending'],
			tags: [],
			dates: [],
			limit: 36,
		};
	},
};

const actions = {
	'deals/list': async function ({ dispatch, commit, state, getters }, { reset = false, type, warmOnly = false }) {
		if (warmOnly) {
			const query = state[`query/${type}`];
			this.$http.get('deals', { params: { offset: 0, limit: query.limit, status: 'active,expired,pending,draft', order_by: 'date' } }).catch(() => {});
			return { ok: true, state: 'complete' };
		}
		commit('SET_DATA_LOADING', { value: true, type });

		const query = state[`query/${type}`];

		let tags = null;
		if (query.tags.length > 0) {
			tags = [];
			query.tags.forEach((t) => {
				tags.push(t.key);
			});
			tags = tags.join(',');
		}

		let status = 'active,expired,pending,draft';
		if (query.status.length > 0) status = query.status.join(',');

		let offset;
		if (reset) offset = 0; else offset = getters[`data/${type}`].results.length;

		let startTime; let endTime; let seeFuture = 1;
		if (query.dates.length > 0) {
			startTime = query.dates[0];
			endTime = query.dates[1];

			if (this.$moment().isBefore(startTime) || this.$moment().isBefore(endTime)) {
				seeFuture = 1;
			} else {
				seeFuture = 0;
			}
		} else {
			startTime = null;
			endTime = null;
		}

		let author = null;
		if (query.author && query.author.length) {
			author = query.author[0].key;
		}
		const seePromoted = query.promoted ? 1 : null;
		const seeAdult = query.adult ? 1 : null;

		let deals;
		// deals = await this._vm.$sdk.deals().list({ offset, search: query.search, limit: query.limit, status, tags, see_future: seeFuture, start_time: startTime, end_time: endTime, show_tags: 1 });
		// La cola de moderación (pending) es admin-only: debe ir AUTENTICADA para que el
		// backend respete status=pending. Sin auth lo trataba como público y devolvía el
		// total de deals públicos (de ahí el badge "+99"). El resto siguen públicos.
		const headers = {};
		if (type !== 'pendingPosts') headers.byPassAuth = true;

		try {
			const response = await this.$http.get(
				'deals', {
					params: {
						offset,
						limit: query.limit,
						search: query.search,
						tags,
						order_by: 'date',
						status,
						see_future: seeFuture,
						start_time: startTime,
						end_time: endTime,
						show_coupons: query.show_coupons,
						show_description: query.show_description,
						show_tags: 1,
						author,
						see_promoted: seePromoted,
						see_adult: seeAdult,
					},
					headers,
				},
			);

			const formatedDeals = [];
			const items = response.data.deals.results;
			const formatDescription = true;
			items.forEach((deal) => {
				if (deal.sale_price) { deal.sale_price = parseFloat(deal.sale_price / 100).toString().replace('.', ','); }
				if (deal.old_price) { deal.old_price = parseFloat(deal.old_price / 100).toString().replace('.', ','); }
				if (deal.description && formatDescription) { deal.description = deal.description.replace(/<\/?[^>]+?>/gi, '').replace(/<\/?[a-z]+?$/i, ''); }

				formatedDeals.push(deal);
			});

			deals = {
				ok: true,
				data: {
					total: response.data.deals.total,
					results: formatedDeals,
				},
				error: null,
			};
		} catch (error) {
			deals = {
				ok: false,
				data: [],
				error: null,
			};
		}
		const result = {
			ok: false,
			state: 'complete',
			total: deals.data.total,
		};

		if (deals.ok) {
			result.ok = true;

			const fetchedCount = deals.data.results.length;
			dispatch('addData', { data: deals.data, type, reset });

			const limit = Number(query.limit) || 0;
			const loadedCount = offset + fetchedCount;
			const totalCount = Number(deals.data.total) || 0;

			const moreByTotal = totalCount > 0 && loadedCount < totalCount;
			const moreByLimit = totalCount === 0 && limit > 0 && fetchedCount === limit;
			const hasMore = fetchedCount > 0 && (moreByTotal || moreByLimit);

			if (hasMore) {
				result.state = 'loaded';
			}
		}

		commit('SET_DATA_LOADING', { value: false, type });

		return result;
	},
	'deals/listAdmin': async function ({ dispatch, commit, state, getters }, { reset = false, type }) {
		commit('SET_DATA_LOADING', { value: true, type });

		const query = state[`query/${type}`];

		let tags = null;
		if (query.tags.length > 0) {
			tags = [];
			query.tags.forEach((t) => {
				tags.push(t.key);
			});
			tags = tags.join(',');
		}

		let status = 'active,expired,pending,draft';
		if (query.status.length > 0) status = query.status.join(',');

		let offset;
		if (reset) offset = 0; else offset = getters[`data/${type}`].results.length;

		let startTime; let endTime; let seeFuture = 1;
		if (query.dates.length > 0) {
			startTime = query.dates[0];
			endTime = query.dates[1];

			if (this.$moment().isBefore(startTime) || this.$moment().isBefore(endTime)) {
				seeFuture = 1;
			} else {
				seeFuture = 0;
			}
		} else {
			startTime = null;
			endTime = null;
		}

		let author = null;
		if (query.author && query.author.length) {
			author = query.author[0].key;
		}
		const seePromoted = query.promoted ? 1 : null;
		const seeAdult = query.adult ? 1 : null;

		let deals;
		const headers = {
			Authorization: true,
		};

		try {
			const response = await this.$http.get(
				'admin/deals', {
					params: {
						offset,
						limit: query.limit,
						search: query.search,
						tags,
						order_by: 'date',
						status,
						see_future: seeFuture,
						start_time: startTime,
						end_time: endTime,
						show_coupons: query.show_coupons,
						show_description: query.show_description,
						show_tags: 1,
						author,
						see_promoted: seePromoted,
						see_adult: seeAdult,
					},
					headers,
				},
			);

			const formatedDeals = [];
			const items = response.data.deals.results;
			const formatDescription = true;
			items.forEach((deal) => {
				if (deal.sale_price) { deal.sale_price = parseFloat(deal.sale_price / 100).toString().replace('.', ','); }
				if (deal.old_price) { deal.old_price = parseFloat(deal.old_price / 100).toString().replace('.', ','); }
				if (deal.description && formatDescription) { deal.description = deal.description.replace(/<\/?[^>]+?>/gi, '').replace(/<\/?[a-z]+?$/i, ''); }

				// Normalizar store: el componente espera un array
				if (!Array.isArray(deal.store)) {
					// Si es un objeto, convertir a array
					if (deal.store && typeof deal.store === 'object') {
						deal.store = [deal.store];
					} else {
						// Si es null/undefined, crear array con objeto vacío
						deal.store = [{ id: null, name: '', image_url: '', url: '' }];
					}
				} else if (deal.store.length === 0) {
					// Si es un array vacío, agregar objeto vacío
					deal.store = [{ id: null, name: '', image_url: '', url: '' }];
				}
				// Normalizar tags: asegurarse que es un array
				if (!Array.isArray(deal.tags)) {
					deal.tags = [];
				}

				formatedDeals.push(deal);
			});

			deals = {
				ok: true,
				data: {
					total: response.data.deals.total,
					results: formatedDeals,
				},
				error: null,
			};
		} catch (error) {
			deals = {
				ok: false,
				data: [],
				error: null,
			};
		}
		const result = {
			ok: false,
			state: 'complete',
			total: deals.data.total,
		};

		if (deals.ok) {
			result.ok = true;

			const fetchedCount = deals.data.results.length;
			dispatch('addData', { data: deals.data, type, reset });

			const limit = Number(query.limit) || 0;
			const loadedCount = offset + fetchedCount;
			const totalCount = Number(deals.data.total) || 0;

			const moreByTotal = totalCount > 0 && loadedCount < totalCount;
			const moreByLimit = totalCount === 0 && limit > 0 && fetchedCount === limit;
			const hasMore = fetchedCount > 0 && (moreByTotal || moreByLimit);

			if (hasMore) {
				result.state = 'loaded';
			}
		}

		commit('SET_DATA_LOADING', { value: false, type });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
